module.exports = __webpack_public_path__ + "img/fondation_sante_gatineau.aee098f9.png";